import { Grid, Theme, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import boxImage from "assets/images/group-14.png";
import useText from "constants/text";
import "styled-components/macro";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      borderRadius: 14,
      margin: "0px 0px 15px 0",
      justifyContent: "space-between",
      width: "100%",
      display: "flex",
      height: "13.5vh",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        width: "93%",
      },
    },
    slogan: {
      display: "flex",
      justifyContent: "space-evenly",
      marginLeft: 20,
    },
    taskTag: {
      fontFamily: "Montserrat",
      fontSize: 24,
      fontWeight: 300,
      lineHeight: 2.08,
      color: "#757a93",
      marginLeft: "10px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "15px",
        lineHeight: "2.1",
      },
    },
    headerIcon: {
      textAlign: "right",
      [theme.breakpoints.down("xs")]: {
        marginRight: "auto",
      },
    },
    imgTask: {
      marginTop: "16px",
      width: "180px",
      marginLeft: "-14px",
      [theme.breakpoints.down("xs")]: {
        height: " 64px",
        width: "101px",
        marginLeft: "22px",
        marginTop: "5px",
      },
    },
  })
);
export interface SloganProps {
  showButton?: boolean;
  isTask?: boolean;
  CustomButton?: any;
}

export function Slogan({ showButton = true, isTask = false, CustomButton = null }: SloganProps) {
  const styles = useStyles();
  const { text } = useText();
  return (
    <Grid className={styles.root}>
      <Grid item xs={7}>
        <Typography className={styles.taskTag} variant="h3">
          {text.all.choose_the_most}&nbsp;
          <b>{text.all.convenient_delivery}</b>
        </Typography>
      </Grid>
      <Grid item xs={2} className={styles.headerIcon}>
        <img src={boxImage} className={styles.imgTask} alt="box images" />
      </Grid>
    </Grid>
  );
}
